import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import $ from 'jquery';
import Header from "./Header.js";
import "../App.css"
import { Link, redirect } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser,faCreditCard,faEnvelope,faPhone,faBuilding,faFlag,faDollar } from '@fortawesome/free-solid-svg-icons'

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import {formatDate, parseResponseJSON,dateDifference, getDataSorted, formatDateText} from "./CommonFunctions";
import InputGroup from 'react-bootstrap/InputGroup';
import {Row,Col} from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import CommonComponents from "./CommonComponents.js";
import { Rate , Divider, Badge, Dropdown,Table} from "rsuite";
import { AddRepair } from "./AddRepair.js";
import PageIcon from '@rsuite/icons/Page';
import NewPost from "./AddImage.js"
import { Box,Button, InputAdornment, TextField } from "@mui/material";
import { DataGrid, gridClasses, GridToolbar, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import { AddExpense } from "./AddExpense.jsx";
import { AddCashout } from "./AddCashout.jsx";
const { Column, HeaderCell, Cell } = Table;
export const Expenses=()=>{
    
    const [expenses,setExpenses] = useState([]);
    const [showAddExpense,setShowAddExpense] = useState(false);
    const [showAddCashout,setShowAddCashout] = useState(false);
    
    const [ currentExpense ,setCurrentExpense] = useState(null);
    
    const url=process.env.REACT_APP_SERVER_URL;
    useEffect(() => {
      
    }, []);
    
  const columns =[
    { field: `id`, headerName: 'Ticket No.', width: 80, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
          return <Link onClick={(e)=>{
            setShowAddExpense(true);
            setCurrentExpense(params.row);
        }}>{currentRow.id}</Link>
    } },
    { field: `entryDate`, headerName: 'Created At', width: 150, align: 'left' },
    { field: `person`, headerName: 'By whom', width: 150, align: 'left' },

    { field: 'description', headerName: 'Description', width: 250, align: 'left',
      renderCell: (params) => {
        return <div style={{ lineHeight: "1.5em",whiteSpace: 'normal', wordBreak: 'break-all',overflowWrap: "anywhere",
          display: "block" }}>
          {params.row.description}
        </div>
      },
     },
    { field: `amount`, headerName: 'Amount', width: 150, align: 'left' },
    { field: `category`, headerName: 'Category', width: 150, align: 'left' },
    { field: `paymentMode`, headerName: 'Payment Mode', width: 150, align: 'left' },
    { field: 'actions', headerName: 'Actions', width: 100, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return <>
        {/* <Link
              onMouseMove={(e)=>handleCloseAddRepair()}
              onTouchMove={(e)=>handleCloseAddRepair()}
                onClick={()=>handleShowAddRepair(currentRow.id)}
              >
                Edit
              </Link>
              <br></br>
              <Link
                onClick={()=>handleShowDeleteRepairPopup(currentRow.id)}
              >
                Delete
              </Link>
              <br></br> */}

        </>
    } },

  ];


    return (
      <div>
        <Header/>
        <Button variant="contained" sx={{margin:1.5}}
        onClick={(e)=>setShowAddExpense(true)}
        >Add Expense</Button>

      <Button variant="contained" sx={{margin:1.5}}
        onClick={(e)=>setShowAddCashout(true)}
        >Add Cashout</Button>
        
      <Box
        sx={{
          height: 550,
          width: '100%',
          '& .actions': {
            color: 'text.secondary',
          },
          '& .textPrimary': {
            color: 'text.primary',
          },
        }}
      >
        <DataGrid rows={expenses} columns={columns} getRowHeight={() => 'auto'} 
        getRowId={(row) => row.id} 
       
        sx={{
          [`& .${gridClasses.cell}`]: {
            py: 1.5,
          },
        }}
        />
        
      </Box>  

      {showAddExpense && <AddExpense showAddExpense={showAddExpense} 
      setShowAddExpense={setShowAddExpense} currentExpense={currentExpense}/>}

      
        



      </div>
    );


}